// ProtectedRoute.jsx
import React from "react";
import { Navigate } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const now = new Date().getTime();

  if (!loginData || now >= loginData.expiry) {
    // اگر لاگین نبود یا اعتبار تمام شده بود
    localStorage.removeItem("loginData");
    return <Navigate to="/login" replace />;
  }

  return children; // اجازه دسترسی
}
